<div class="bg-white p-3">
    <h6 class="text-primary mt-2 common-bene-class-for-translation" id="sectionHead1">Passport</h6>
    <div class="mb-3">
        <p-table [value]="loadData?.Personal" [resizableColumns]="true" styleClass="p-datatable-gridlines">
            <ng-template pTemplate="header">
                <tr>
                    <th class="common-bene-class-for-translation" id="section1TableHead1">Document Name</th>
                    <th class="common-bene-class-for-translation" id="section1TableHead2">Valid From</th>
                    <th class="common-bene-class-for-translation" id="section1TableHead3">Valid To</th>
                    <th class="common-bene-class-for-translation" id="section1TableHead4">Action</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-loadData let-ri="rowIndex">
                <tr>
                    <td><span *ngIf="loadData?.fileName" class="common-bene-class-for-translation" id="fileName-{{ri}}">{{loadData?.fileName}}</span><span *ngIf="!loadData?.fileName">--</span></td>
                    <td><span *ngIf="loadData?.validityStartDate" class="common-bene-class-for-translation" id="validityStartDate-{{ri}}">{{loadData?.validityStartDate | ImgDateFormat}}</span><span *ngIf="!loadData?.validityStartDate">--</span></td>
                    <td><span *ngIf="loadData?.validityStartDate" class="common-bene-class-for-translation" id="validityEndDate-{{ri}}">{{loadData?.validityEndDate | ImgDateFormat}}</span><span *ngIf="!loadData?.validityEndDate">--</span></td>
                    <td>
                        <div class="row">
                          <div> <i class="fa fa-edit pr-2 icn" title="Edit" (click)="openEditPopup(loadData)"></i> </div>
                        </div>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-loadData>
                <tr>
                  <td [attr.colspan]="4" class="text-center common-bene-class-for-translation" id="noRecordsSection1">
                     No records found
                  </td>
                </tr>
              </ng-template>
        </p-table>
    </div>

    <h6 class="text-primary common-bene-class-for-translation" id="sectionHead2">Visa Details</h6>
    <div class="immigrationContainer spacing im-card-no-border-table">
        <table class="im-card-no-border-table" multiTemplateDataRows mat-table [dataSource]="dataSource">
            
            <ng-container *ngFor="let column of columns; let indx = index" [matColumnDef]="column.columnDef">
            <th mat-header-cell *matHeaderCellDef class="common-bene-class-for-translation" id="colHeaderLbl10{{indx}}">{{ column.header }}</th>
            
            <td mat-cell *matCellDef="let row; let i = renderIndex">
                <span *ngIf="column.columnDef == 'toggle'" class="toggle-col"> 
                <mat-icon matTooltip="View more" class="mr-1 icn">expand_more</mat-icon>
                </span>
                <span class="common-bene-class-for-translation" id="colTextLbl10_{{indx}}__{{i}}" *ngIf="column.columnType == 'text'">
                {{ row[column.columnDef] }}
                </span>
                <span *ngIf="column.columnDef == 'action'">
                    <div> <i class="fa fa-edit pr-2 icn" title="Edit" (click)="openEditPopup(row)"></i> </div>
                </span>
            </td>
            </ng-container>


            <div class="example-element-description">

            <ng-container matColumnDef="expandedDetail">
                
                <td class="w40" mat-cell *matCellDef="let element; let ix = renderIndex" [attr.colspan]="columns.length">
                <div class="example-element-detail" [@detailExpand]="
                    element == expandedElement ? 'expanded' : 'collapsed'">
                    <div class="w100 example-element-description py-1 mt-1">
                    <h6 class="common-bene-class-for-translation" id="i-94-history{{ix}}">I-94 History</h6>
                    <ng-container>
                        <table class="im-card-no-border-table border">
                        <thead>
                            <tr>
                                <th class="common-bene-class-for-translation" id="i-94-number{{ix}}">I-94 Number</th>
                                <th class="common-bene-class-for-translation" id="portHead{{ix}}">Port</th>
                                <th class="common-bene-class-for-translation" id="motHead{{ix}}">Mode Of Travel</th>
                                <th class="common-bene-class-for-translation" id="arrivalDateHead{{ix}}">Arrival Date</th>
                                <th class="common-bene-class-for-translation" id="exitDateHead{{ix}}">Exit Date</th>
                                <th class="common-bene-class-for-translation" id="expiryDateHead{{ix}}">Expiry Date</th>
                                <th class="common-bene-class-for-translation" id="actionHead{{ix}}">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngIf="element.travelInfo?.length">
                                <tr *ngFor="let travel of element.travelInfo; let i = index">
                                    <td nowrap class="common-bene-class-for-translation" id="i94Number{{ix}}_{{i}}">
                                    {{ travel.i94Number }}
                                    </td>
                                    <td nowrap class="common-bene-class-for-translation" id="portOfEntry{{ix}}_{{i}}">
                                        {{ travel.portOfEntry }}
                                    </td>
                                    <td class="common-bene-class-for-translation" id="meansOfTravel{{ix}}_{{i}}">
                                        {{ travel.meansOfTravel }}
                                        </td>
                                    <td class="common-bene-class-for-translation" id="ImgDateFormat{{ix}}_{{i}}">
                                    {{ travel.arrivalDate | ImgDateFormat }}
                                    </td>
                                    <td nowrap class="common-bene-class-for-translation" id="exitDate{{ix}}_{{i}}">
                                        {{ travel.exitDate | ImgDateFormat }}
                                        </td>
                                    <td class="common-bene-class-for-translation" id="i94ExpiryDate{{ix}}_{{i}}">
                                    {{ travel.i94ExpiryDate | ImgDateFormat }}
                                    </td>
                                    <td nowrap>
                                        <div> <i class="fa fa-edit pr-2 icn" title="Edit" (click)="openEditPopup(travel, true, element.beneficiaryId)"></i> </div>
                                    </td>       
                                </tr>
                            </ng-container>
                            <tr *ngIf="!element.travelInfo?.length">
                                <td colspan="6" class="text-center common-bene-class-for-translation" id="noRecords-travelInfo">No records found</td>
                            </tr>
                        </tbody>
                        </table>
                    </ng-container>
                    </div>
                    <div class="w100 example-element-description py-1 mt-3">
                    <h6 class="common-bene-class-for-translation" id="uploaded-dox{{ix}}">Uploaded Documents</h6>
                    <ng-container>
                        <table class="im-card-no-border-table border mb-2">
                            <thead>
                                <tr>
                                <th class="common-bene-class-for-translation" id="docType-head{{ix}}">Document Type</th>
                                <th class="common-bene-class-for-translation" id="name-head{{ix}}">Name</th>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-container *ngIf="element.documentList?.length">
                                    <tr *ngFor="let item of element.documentList; let i = index">
                                        <td nowrap class="common-bene-class-for-translation" id="docTypeValue{{ix}}_{{i}}">
                                        <!-- IM-8688 -->
                                        {{ item?.fileCategory?.code === 'OTHER' ? item?.fileCategoryOtherName :
                                        item?.fileCategory?.name }}
                                        </td>
                                        <td>
                                        <strong class="common-bene-class-for-translation" id="fileNameValue{{ix}}_{{i}}">{{ item.fileName }}</strong>
                                        </td>
                                    </tr>   
                                </ng-container>
                                <tr *ngIf="!element.documentList?.length">
                                    <td colspan="2" class="text-center common-bene-class-for-translation" id="noRecordsDocType">No records found</td>
                                </tr>
                            </tbody>
                        </table>
                    </ng-container>
                    </div>
                </div>
                </td>
            </ng-container>
            </div>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let element; columns: displayedColumns" class="example-element-row"
            [class.example-expanded-row]="expandedElement === element"
            (click)="expandedElement = expandedElement === element ? null : element"></tr>
            <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
        </table>
      </div>


      <p-dialog appendTo="body" [draggable]="false"
                [resizable]="false" [modal]="true" #editDocs [(visible)]="isVisible" [style]="{width: '50vw'}">
                <p-header id="pop_header_unique" class="common-bene-class-for-translation">
                    Update
                </p-header>
                  <ng-template pTemplate="content">
                    <hr class="my-0" />
                    <div *ngIf="selectedDoc" class="row margin-adjust mt-3">
                      <!-- <div class="col-6">
                        <label>Document Type</label>
                      <h6>{{selectedDoc?.fileCategory?.name}}</h6>
                      </div>
                      <div class="col-6">
                        <label>Document Name</label>
                        <h6>{{selectedDoc?.fileName}}</h6>
                      </div> -->
                      <div class="col-6 mt-3" *ngIf="!isI94Edit">
                        <label class="common-bene-class-for-translation" id="popup-validFrom">Valid From</label>
                        <p-calendar  class="im-input-calendar mw-100" id="startDate" appendTo="body"
                        styleClass="p-form-datepicker" [(ngModel)]="selectedDoc.validityStartDate"
                        inputId="startDate" [showIcon]="true" dateFormat="mm/dd/yy"
                        placeholder="MM/DD/YYYY">
                        </p-calendar>
                      </div>
                      <div class="col-6 mt-3" *ngIf="!isI94Edit">
                        <label class="common-bene-class-for-translation" id="popup-validTo">Valid To</label>
                        <p-calendar class="im-input-calendar mw-100" id="startDate" appendTo="body"
                        styleClass="p-form-datepicker" [(ngModel)]="selectedDoc.validityEndDate"
                        inputId="startDate" [showIcon]="true" dateFormat="mm/dd/yy"
                        placeholder="MM/DD/YYYY">
                        </p-calendar>
                      </div>
                      <div class="col-6 mt-3" *ngIf="isI94Edit">
                        <label class="common-bene-class-for-translation" id="popup-arrivalDate">Arrival Date</label>
                        <p-calendar class="im-input-calendar mw-100" id="expiryDate" appendTo="body"
                        styleClass="p-form-datepicker" [(ngModel)]="selectedDoc.arrivalDate"
                        inputId="startDate" [showIcon]="true" dateFormat="mm/dd/yy"
                        placeholder="MM/DD/YYYY">
                        </p-calendar>
                      </div>
                      <div class="col-6 mt-3" *ngIf="isI94Edit">
                        <label class="common-bene-class-for-translation" id="popup-expiryDate">Expiry Date</label>
                        <p-calendar class="im-input-calendar mw-100" id="expiryDate" appendTo="body"
                        styleClass="p-form-datepicker" [(ngModel)]="selectedDoc.i94ExpiryDate"
                        inputId="startDate" [showIcon]="true" dateFormat="mm/dd/yy"
                        placeholder="MM/DD/YYYY">
                        </p-calendar>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template pTemplate="footer">
                    <div class="text-left">
                      <button id="cancel-button-popup" type="button" class="btn btn-secondary common-bene-class-for-translation" (click)="closeEditModal()" >Cancel</button>
                      <button id="save-button1-popup" *ngIf="!isI94Edit" [disabled]="!selectedDoc.validityStartDate || !selectedDoc.validityEndDate" class="btn btn-primary btn-sm mr-3 common-bene-class-for-translation" (click)="saveDocDates()">Save</button>
                      <button id="save-button2-popup" *ngIf="isI94Edit" [disabled]="!selectedDoc.arrivalDate || !selectedDoc.i94ExpiryDate" class="btn btn-primary btn-sm mr-3 common-bene-class-for-translation" (click)="saveDocDates()">Save</button>
                    </div>
                  </ng-template>
    </p-dialog>
</div>